<div *ngIf="isDataGridOpened" class="content-wrapper__data-grid">
  <app-side-grid
    [data]="vehiclesData.vehicleMakes"
    [selectionName]="vehicleMakeGridSelectionName"
    [columns]="vehicleMakeGridColumns"
    [selections]="selections"
    (setSelections)="setSelections($event.newFilters, $event.resetOther, vehicleMakeGridSelectionName)"
    [loadingInProgress]='isLoadingUpdate'
  />
</div>

<div class="content-wrapper vehicles__wrapper" #scrollContainer>
  <div class="loading" *ngIf="isLoadingInitialData">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!isLoadingInitialData" [className]="'vehicles ' + (fullScreenChart? ('fullscreen-mode__'+fullScreenChart): '')">
    <div class="vehicles__by-color">
      <app-card name="Vehicle Color" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('0')">
        <app-pie-chart
          #vehicleColorChart
          beforeTitleTooltip="VehicleColor"
          titleTooltip="Count of Citation"
          [name]="vehicleColorChartName"
          [generateData]="generateResultByColor"
          [options]="resultByColorChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, vehicleColorChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="vehicles__by-type">
      <app-card name="Vehicle Type" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('1')">
        <app-pie-chart
          #vehicleTypeChart
          beforeTitleTooltip="VehicleType"
          titleTooltip="Count of Citation"
          [name]="vehicleTypeChartName"
          [generateData]="generateResultByType"
          [options]="resultByTypeChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, vehicleTypeChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="vehicles__by-month">
      <app-card name="Citations - Newer vs Older" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('2')">
        <app-vehicle-by-month
          #vehicleByMonthChart
          [name]="byMonthChartName"
          [newerOlderSelectionName]="byMonthNewerOlderSelectionName"
          [vehicles]="vehiclesData.citationsByVehicleAge.values"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, byMonthChartName)"
          (setNewerOlderSelections)="setSelections($event.newFilters, $event.resetOther, byMonthNewerOlderSelectionName)"
        />
      </app-card>
    </div>
  </div>
</div>

<ng-template #leftPanelTemplate>
  <app-grid-button title="Vehicle Make" [isDataGridOpened]="isDataGridOpened" (toggleDataGrid)="toggleDataGrid()" />
</ng-template>
